import Vue from "vue";
export const EventTimer = new Vue();